const STORAGE_PREFIX = "argos:user-filters";

function buildKey(userId, pageKey) {
    if (!pageKey) return null;
    return userId
        ? `${STORAGE_PREFIX}:${userId}:${pageKey}`
        : `${STORAGE_PREFIX}:global:${pageKey}`;
}

export function readUserPageFilters(userId, pageKey) {
    const key = buildKey(userId, pageKey);
    if (!key) return {};

    try {
        const raw = window.localStorage.getItem(key);
        if (!raw) return {};

        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch (_) {
        return {};
    }
}

export function writeUserPageFilters(userId, pageKey, patch) {
    const key = buildKey(userId, pageKey);
    if (!key || !patch || typeof patch !== "object") return;

    try {
        const current = readUserPageFilters(userId, pageKey);
        const next = { ...current, ...patch };
        window.localStorage.setItem(key, JSON.stringify(next));
    } catch (_) {
        // best-effort
    }
}

export function clearUserPageFilters(userId, pageKey) {
    const key = buildKey(userId, pageKey);
    if (!key) return;

    try {
        window.localStorage.removeItem(key);
    } catch (_) {
        // best-effort
    }
}